import Image from "next/image";
import Link from "@/components/Link";

export interface RecentPostItem {
  id: string;
  title: string;
  href: string;
  photoURL?: string;
  meta?: string;
}

export default function SidebarRecentPostsWidget({
  title,
  items,
  sticky = false,
  stickyTop = 30,
}: {
  title: string;
  items: RecentPostItem[];
  sticky?: boolean;
  stickyTop?: number;
}) {
  if (!items.length) return null;

  return (
    <div
      className={`widget${sticky ? " position-sticky" : ""}`}
      style={sticky ? { top: `${stickyTop}px` } : undefined}
    >
      <h3 className="widget_title">{title}</h3>
      <div className="recent-post-wrap">
        {items.map((item) => (
          <div key={item.id} className="recent-post">
            {item.photoURL && (
              <div className="media-img">
                <Link href={item.href} title={item.title}>
                  <Image
                    src={item.photoURL}
                    alt={item.title}
                    width={80}
                    height={80}
                    unoptimized
                    style={{
                      objectFit: "cover",
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </Link>
              </div>
            )}
            <div className="media-body">
              <h4 className="post-title mb-1">
                <Link className="text-inherit" href={item.href} title={item.title}>
                  {item.title}
                </Link>
              </h4>
              {item.meta && (
                <div className="recent-post-meta">
                  <a href={item.href} title={item.title}>
                    <i className="fa-regular fa-clock"></i>
                    {item.meta}
                  </a>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
